import { Loader2, RefreshCw, Clock, AlertTriangle, Gauge } from "lucide-react";
import { Button } from "./ui/button";

// Step 2 before the front render exists: POST /creations answers 202 straight away and the render runs in a
// background job, so the customer watches progress here instead of waiting on a request that the edge would cut off.
export const RenderPending = ({ creation, onRedo, busy }) => {
  const failed = creation.build_status === "failed";
  const capped = creation.build_status === "waiting" && creation.cap_blocked;
  const queued = creation.build_status === "waiting" && !capped;

  return (
    <div data-testid="render-pending" className="rounded-3xl border border-border bg-card p-6 sm:p-8">
      <div className="flex flex-col sm:flex-row gap-6 items-start">
        {creation.photo && (
          <img src={creation.photo} alt="Your photo" className="w-28 h-28 rounded-2xl object-cover border border-border shrink-0" />
        )}
        <div className="flex-1 min-w-0">
          {failed ? (
            <>
              <p data-testid="render-pending-failed" className="flex items-start gap-2 font-heading text-lg font-extrabold">
                <AlertTriangle className="h-5 w-5 mt-0.5 shrink-0 text-amber-500" />
                {creation.build_error || "The duck render did not finish."}
              </p>
              <p className="mt-2 text-sm text-muted-foreground">Nothing was lost — your photo is saved. Tap Redo to try again.</p>
            </>
          ) : capped ? (
            <>
              <p data-testid="render-pending-capped" className="flex items-start gap-2 font-heading text-lg font-extrabold">
                <Gauge className="h-5 w-5 mt-0.5 shrink-0 text-rose-500" /> Your duck is saved — waiting for a top-up
              </p>
              <p className="mt-2 text-sm text-muted-foreground">{creation.build_error}</p>
            </>
          ) : queued ? (
            <>
              <p data-testid="render-pending-queued" className="flex items-start gap-2 font-heading text-lg font-extrabold">
                <Clock className="h-5 w-5 mt-0.5 shrink-0 text-sky-500" />{" "}
                {creation.ai_limit_blocked ? "Your duck is waiting for the AI service" : "Your duck is in the queue"}
              </p>
              <p className="mt-2 text-sm text-muted-foreground">
                {creation.build_error || "It will carry on by itself as soon as generation resumes — nothing is lost."}
              </p>
            </>
          ) : (
            <>
              <p data-testid="render-pending-working" className="flex items-start gap-2 font-heading text-lg font-extrabold">
                <Loader2 className="h-5 w-5 mt-0.5 shrink-0 animate-spin text-accent" /> Making your duck…
              </p>
              <p className="mt-2 text-sm text-muted-foreground">
                Matching printed references and drawing the front view. About a minute — you can leave this page and come back.
              </p>
            </>
          )}
          {(creation.build_stages || []).length > 0 && (
            <ul data-testid="render-pending-stages" className="mt-4 space-y-1 text-xs font-mono2 text-muted-foreground">
              {creation.build_stages.map((s) => (
                <li key={s.name}>
                  {s.ended_at ? "✓" : "…"} {s.name}
                </li>
              ))}
            </ul>
          )}
          {(failed || queued) && (
            <Button data-testid="render-pending-redo" variant="outline" disabled={!!busy} onClick={onRedo} className="mt-5 rounded-full gap-2">
              <RefreshCw className="h-4 w-4" /> Redo
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};
